import React, { useEffect } from "react";

const CookieBanner = () => {
  useEffect(() => {
    const configScript = document.createElement("script");
    configScript.type = "text/javascript";
    configScript.async = true;
    configScript.innerHTML = `
      var _iub = _iub || [];
      _iub.csConfiguration = {
        "askConsentAtCookiePolicyUpdate": true,
        "enableFadp": true,
        "enableLgpd": true,
        "enableUspr": true,
        "fadpApplies": false,
        "floatingPreferencesButtonDisplay": false,
        "localConsentDomain": "https://webrep.codertd.com/",
        "perPurposeConsent": true,
        "siteId": 3352336,
        "usprApplies": true,
        "whitelabel": false,
        "cookiePolicyId": 14774579,
        "lang": "it",
        "banner": {
          "acceptButtonDisplay": true,
          "closeButtonDisplay": false,
          "customizeButtonDisplay": true,
          "explicitWithdrawal": true,
          "listPurposes": true,
          "position": "float-bottom-center",
          "rejectButtonDisplay": true
        }
      };
    `;

    document.body.appendChild(configScript);

    const loadScript = (src: string) => {
      const script = document.createElement("script");
      script.src = src;
      script.type = "text/javascript";
      script.async = true;
      document.body.appendChild(script);
    };

    loadScript("https://cs.iubenda.com/autoblocking/3352336.js");
    loadScript("//cdn.iubenda.com/cs/gpp/stub.js");
    loadScript("//cdn.iubenda.com/cs/iubenda_cs.js");

    return () => {
      document.body.removeChild(configScript);
    };
  }, []);

  return null;
};

export default CookieBanner;
